import { Box, Button, Stack, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { applicationPayment } from '../../domain/raise/raiseCalc';
import { date, money } from '../../lib/format';
import { useInvestorScope } from '../../store/selectors';
import { StatusChip } from '../../ui/primitives';
import { Card, SectionLabel } from '../common';

export default function ApplicationsPanel() {
  const scope = useInvestorScope();
  const navigate = useNavigate();
  const active = scope.applications.filter(
    (application) => !['REJECTED', 'WITHDRAWN'].includes(application.status),
  );
  const investorLabel = (application: (typeof active)[number]) => {
    if (application.status === 'PENDING_APPROVAL') return 'Being approved';
    const atClose = scope.offers.some(
      (offer) => offer.classId === application.classId && offer.issueAtClose,
    );
    if (!atClose || !application.submittedAt || application.status === 'ISSUED') return undefined;
    const payment = applicationPayment(
      application,
      scope.classes.find((item) => item.id === application.classId),
    );
    return payment.status === 'PAID' ? 'Paid · units at financial close' : 'Payment due';
  };
  const openOffers = scope.offers.filter(
    (offer) =>
      offer.showInInvestorCentre &&
      !active.some((application) => application.fundId === offer.fundId),
  );
  if (active.length === 0 && openOffers.length === 0) return null;
  return (
    <>
      <SectionLabel>Applications</SectionLabel>
      <Stack spacing={1.25}>
        {active.map((application) => (
          <Card key={application.id} onClick={() => navigate(`/investor/apply/${application.id}`)}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
              <Box sx={{ minWidth: 0 }}>
                <Typography sx={{ fontWeight: 700 }}>
                  {scope.funds.find((fund) => fund.id === application.fundId)?.name}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {application.reference} · {money(application.amount)}
                </Typography>
              </Box>
              <StatusChip status={application.status} label={investorLabel(application)} />
            </Stack>
          </Card>
        ))}
        {openOffers.map((offer) => (
          <Card key={offer.id}>
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              justifyContent="space-between"
              alignItems={{ sm: 'center' }}
              spacing={1.5}
            >
              <Box>
                <Typography sx={{ fontWeight: 700 }}>
                  {scope.funds.find((fund) => fund.id === offer.fundId)?.name} is open
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Min {money(offer.minInvestment)} · closes {date(offer.closesAt)} · apply with your
                  details pre-filled
                </Typography>
              </Box>
              <Stack direction="row" spacing={1}>
                <Button onClick={() => navigate(`/investor/offers/${offer.id}`)}>View offer</Button>
                <Button
                  variant="contained"
                  onClick={() => navigate(`/investor/apply/new?fund=${offer.fundId}`)}
                >
                  Apply now
                </Button>
              </Stack>
            </Stack>
          </Card>
        ))}
      </Stack>
    </>
  );
}
